// src/DraggableFormElement.js

import React from "react";
import {
  Box,
  Text,
  Textarea,
  HStack,
  IconButton,
  Tooltip,
  FormControl,
  FormLabel,
  Switch,
  Input,
  VStack

} from "@chakra-ui/react";
import { useEffect } from "react";
import { DeleteIcon, CopyIcon, ArrowUpIcon, ArrowDownIcon } from "@chakra-ui/icons";
import { useTranslation } from "react-i18next";

function DraggableDatePickerCreationElement({
  element,
  onDelete,
  onCopy,
  onMoveUp,
  onMoveDown,
  onChangeData,



  isMatrixDropdownElement,
  onDeleteMatrixDropdown,

  onCopyMatrixDropdown,
  onMoveUpMatrixDropdown,
  onMoveDownMatrixDropdown

}) {
  const {t}= useTranslation();
  useEffect(() => {
    
    if (element.isRequired == null) {
      onChangeData(element.id, "isRequired", false);
    }
  }, []);
  return (
    <Box
      
      bg="white"
      border="1px solid"
      borderColor="gray.300"
      borderRadius="md"
      p={4}
      shadow="sm"
      
      position="relative"
      width="100%"
    >
      {/* Action Buttons */}
      <HStack spacing={2} position="absolute" top={2} left={2}>
        <Text fontWeight="bold" fontSize="md">
          DatePicker {t('survey.htmlQuestion.question')}
        </Text>

         {!element.disabled && (
             <Tooltip label={t('survey.iconQuestion.delete')} fontSize="sm">
             <IconButton
               size="sm"
               aria-label="Delete"
               icon={<DeleteIcon />}
               onClick={() => { isMatrixDropdownElement ? onDeleteMatrixDropdown() : onDelete() }}
             />
           </Tooltip>
            )}
      

      {!element.disabled && (
             <Tooltip label={t('survey.iconQuestion.copy')} fontSize="sm">
             <IconButton
               size="sm"
               aria-label="Copy"
               icon={<CopyIcon />}
               onClick={() => { isMatrixDropdownElement ? onCopyMatrixDropdown() : onCopy() }}
             />
           </Tooltip>
            )}
      
       
       
        <Tooltip label={t('survey.iconQuestion.moveUp')} fontSize="sm">
          <IconButton
            size="sm"
            aria-label="Move Up"
            icon={<ArrowUpIcon />}
            onClick={() => { isMatrixDropdownElement ? onMoveUpMatrixDropdown() : onMoveUp() }}
          />
        </Tooltip>
        <Tooltip label={t('survey.iconQuestion.moveDown')} fontSize="sm">
          <IconButton
            size="sm"
            aria-label="Move Down"
            icon={<ArrowDownIcon />}


            onClick={() => { isMatrixDropdownElement ? onMoveDownMatrixDropdown() : onMoveDown() }}
          />
        </Tooltip>
      </HStack>

      {/* Form Element Details */}
      <VStack mt={8} align="start" spacing={4}>
        {/* Field Name */}
      
        
        {/* Title */}
        <FormControl>
          <FormLabel fontWeight="bold">{t('survey.htmlQuestion.title')}</FormLabel>
          <Input
            value={element.title}
            isDisabled={element.disabled}
            placeholder={t('survey.htmlQuestion.enterTitle')}
            onChange={(e) => onChangeData(element.id, "title", e.target.value)}
          />
        </FormControl>

     

      {/* Name */}
      <FormControl>
          <FormLabel fontWeight="bold">{t('survey.htmlQuestion.tag')}</FormLabel>
          <Input
            value={element.name}
            isDisabled={element.disabled}
            placeholder={t('survey.htmlQuestion.enterTag')}
            onChange={(e) => onChangeData(element.id, "name", e.target.value)}
          />
         </FormControl>



         <FormControl>
          <FormLabel fontWeight="bold">InputType</FormLabel>
          <Input
            value={element.inputType}
            isDisabled={element.disabled}
            placeholder={"InputType"}
            onChange={(e) => onChangeData(element.id, "inputType", e.target.value)}
          />
         </FormControl>


         <FormControl>
          <FormLabel fontWeight="bold">DateFormat</FormLabel>
          <Input
            value={element.dateFormat}
            isDisabled={element.disabled}
            placeholder={"DateFormat"}
            onChange={(e) => onChangeData(element.id, "dateFormat", e.target.value)}
          />
         </FormControl>



       
      


      

        {/* Required Field Switch */}
        <FormControl display="flex" alignItems="center">
          <FormLabel mb="0" fontWeight="bold">
          {t('survey.htmlQuestion.required')}
          </FormLabel>
          <Switch
            isChecked={element.isRequired}
            isDisabled={element.disabled}
            onChange={(e) => onChangeData(element.id, "isRequired", e.target.checked)}
          />
        </FormControl>

        {/* Rate Max Slider */}
      
      </VStack>
    </Box>
  );
}

export default DraggableDatePickerCreationElement;
